<template>
  <section class="faq-section" id="faq">
    <div class="container">
      <div class="row center-lg align-left">
        <div class="col-xs-12 col-gi-10">
          <h3 class="faq-title small margin-bottom">
            Auto verkaufen - <br />die häufigsten Fragen (FAQ)
          </h3>

          <div class="faq-container">
            <div class="faq-card" v-for="(faq, index) in faqList" :key="index">
              <div
                class="faq-title"
                :class="{ active: selectedIndex === index }"
                @click="toggle(index)"
              >
                {{ faq.title }}
              </div>
              <CollapseTransition dimension="height">
                <div
                  class="faq-content"
                  v-show="selectedIndex === index"
                  v-html="faq.description"
                ></div>
              </CollapseTransition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
export default {
  name: "FAQ",
  components: {
    CollapseTransition
  },
  props: ['fee'],
  computed: {
    faqList() {
      return [
      {
        title: "Auto verkaufen - Was muss ich beachten?",
        description:
          "<p>Wenn du dein Auto online bei PKW.de verkaufst - wenig. Du erstellst bequem mit ein paar Klicks ein Expose, legst den Startpreis, Auktionslänge und gegebenenfalls einen Sofortkaufpreis fest und erhältst ein Höchstgebot von einem geprüften Händler. Abmeldung und Transport übernimmt der Käufer - kostenlos für dich.</p>"
      },
      {
        title: "Was kostet der Online-Verkauf?",
        description:
          `<p>Nichts! Unser Service rund um den Online-Verkauf deines Fahrzeugs ist komplett kostenlos für Sie. </p>`
      },
      {
        title: "Mein Auto online verkaufen – wo geht das?",
        description:
          "<p>Kleidung, Handys und auch Autos. Gebrauchtes verkauft man heute bequem und sicher online. Deinen Gebrauchtwagen kannst du kostenlos auf PKW.de verkaufen. Schnell und ohne Risiko. Zusammen mit dir legen wir den Startpreis fest. Du erhältst dann ein Höchstgebot von einem unserer geprüften Händler. Bezahlung, Abholung und Abmeldung übernimmt der Käufer - du musst dich um nichts weiter kümmern.</p>"
      },
      {
        title: "Wer bietet auf mein Auto?",
        description:
          "<p>Bei uns dürfen nur geprüfte und zertifizierte Händler mitbieten. PKW.de schafft eine deutschlandweite, große Verkaufsplattform. Durch unser umfassendes Netzwerk von mehreren tausend Partnerhändlern können wir ein bestmögliches Kaufangebot für dein Auto erzielen.</p>"
      },
      {
        title: "Kann ich mein altes Auto für ein neues in Zahlung geben?",
        description:
          '<p>Ja, klar! Suche dir auf unserer Seite ganz einfach ein neues Auto online aus. Wenn wir dein neues Wunschfahrzeug zu dir nach Hause liefern, holen wir deinen Gebrauchten ab.</p><p>Auto online kaufen: <a href="https://www.pkw.de/auto-online-kaufen/" title="Auto verkaufen">https://www.pkw.de/auto-online-kaufen/</a></p>'
      },
      {
        title: "Wie wird der Preis ermittelt?",
        description:
          "<p>Der Preis wird transparent, fair und marktaktuell durch unsere TÜV-zertifizierte Marktwertanalyse ermittelt. Dabei werden alle wertbeeinflussenden Faktoren, wie z. B. Ausstattung, Alter, Laufleistung etc., berücksichtigt. Je mehr Informationen eingegeben werden, desto besser können wir den Preis ermitteln.</p>"
      },
      {
        title: "Wird mein Auto abgeholt?",
        description:
          "<p>Das kannst du frei entscheiden! Der Händler kann dein Auto an dem von dir gewünschten Ort selbst abholen oder den PKW.de-Transportservice beauftragen. Für dich entstehen keine Kosten. Alternativ kannst du dein Auto selbst zum Händler fahren.</p>"
      },
      {
        title:
          "Muss ich mein Auto verkaufen, sobald ich ein Angebot von einem Händler erhalten habe?",
        description:
          `<p>Nein! Du entscheidest, ob du dein Auto zum gebotenen Preis verkaufen möchtest oder nicht. Unser PKW.de-Team hilft dir gern bei dieser Entscheidung. </p>`
      },
      {
        title: "Werde ich von verschiedenen Händlern kontaktiert?",
        description:
          `<p>Der Online-Verkauf ist anonym. Erst bei einem Höchstgebot setzen wir uns mit dem höchstbietenden Händler in Verbindung und übermitteln deine Kontaktdaten, damit ihr Bezahlung, Abholung und Abmeldung des Fahrzeugs klären könnt. Dir entstehen dabei keine Kosten. </p>`
      },
      {
        title: "Wieso muss mein Auto begutachtet werden?",
        description:
          "<p>Unser Ziel ist es, so viel wie möglich für dein Auto zu erzielen. Unseren zertifizierten Händlern stellen wir deshalb eine bestmögliche Beschreibung deines Fahrzeugs zur Verfügung. Die Händler können so ohne Bedenken ihr Höchstgebot abgeben.</p>"
      },
      {
        title: "Was passiert, wenn ich kein Kaufangebot erhalte?",
        description:
          "<p>Es ist selten, kommt aber vor! Wir geben unser Bestes, um einen höchstmöglichen Preis für deinen Gebrauchtwagen zu erzielen. Es kann jedoch passieren, dass wir kein passendes Händlerangebot finden können. In diesem Fall beraten wir dich gerne über weitere Verkaufsmöglichkeiten.</p>"
      },
      {
        title: "Wie erfolgt die Abmeldung?",
        description:
          "<p>Sofern du dein Auto nicht selbst oder durch den Händler abmelden lassen möchten, übernehmen wir dies gerne für dich. Die Abmeldung erfolgt über unseren Zulassungsdienstleister gegen ein Entgelt.</p>"
      },
      {
        title: "Das erste Auto verkaufen?",
        description:
          "<p>Das erste eigene Auto ist ein besonderer Meilenstein im Leben. Und wenn es dann ein neues Auto sein darf, kannst du deinen Gebrauchtwagen ganz bequem bei PKW.de in Zahlung geben oder direkt verkaufen.</p>"
      },
      {
        title: "Diesel Auto verkaufen?",
        description:
          "<p>Die Preise für Diesel an den Tankstellen steigen und sind deutlich teurer als Benzin. Auch die Kfz-Steuer für Diesel-Fahrzeuge wird regelmäßig erhöht. Wenn du deinen Diesel verkaufen möchtest, kannst du das schnell und sicher in unserer Auktion mit wenigen Klicks erledigen.</p>"
      },
      {
        title: "Geerbtes Auto verkaufen?",
        description:
          '<p>Falls du ein Auto geerbt hast, kannst du es auch schnell und unkompliziert bei <a href="https://www.pkw.de/" title="PKW.de">PKW.de</a> verkaufen. Durch die unabhängige Fahrzeugbewertung bekommst du einen guten Eindruck vom späteren Verkaufspreis und kannst dir so mit einer möglichen Erbengemeinschaft in Ruhe Gedanken zum Verkauf machen. Zur Abmeldung und Ummeldung benötigst du wie üblich: Fahrzeugschein (Zulassungsbescheinigung Teil I), Fahrzeugbrief (Zulassungsbescheinigung Teil II), Prüfbericht der letzten Hauptuntersuchung und den Erbschein.</p>'
      },
      {
        title: "Warum Auto nur an Händler verkaufen?",
        description:
          "<p>Professionelle Händler bieten mehr Sicherheit. Kein lästiges Nachverhandeln und Feilschen um den Preis, Hilfe bei Abmeldung und um den Transport wird sich auch gekümmert. Dadurch, dass du dein Auto bei PKW.de an Händler in ganz Deutschland anbietest, profitierst du von regionalen Preisunterschieden und verkaufst dein Auto zum Höchstpreis: ohne Papierkram.</p>"
      }
    ]
    }
  },
  data: () => ({
    selectedIndex: null,
    
  }),
  methods: {
    toggle(index) {
      if (this.selectedIndex === index) {
        this.selectedIndex = null;
      } else {
        this.selectedIndex = index;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

.faq-section {
  background: $light-gray;
  padding: 40px 0 20px;

  @include breakpoint(frommediumlarge) {
    padding: 50px 0;
  }

  @include breakpoint(fromgiant) {
    padding: 100px 0;
  }

  h3.faq-title {
    br {
      @include breakpoint(frommediumlarge) {
        display: none;
      }
    }
  }
}
.faq-container {
  padding-top: 17px;

  @include breakpoint(frommediumlarge) {
    padding-top: 0;
  }

  @include breakpoint(fromgiant) {
    padding-top: 17px;
  }
  &.responsive {
    @media screen and (min-width: 650px) {
      display: grid;
      gap: 0 18px;
      grid-template-columns: 1fr 1fr;
    }
  }
}
.faq-card {
  margin-bottom: 25px;
  display: block;

  .question {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .prefix-icon {
      margin-right: 13px;
      padding-top: 4px;
      .icon {
        font-size: 32px;
      }

      &.small-icon {
        .icon {
          font-family: "Glyphter", sans-serif;
          color: rgba(#444, 0.5);
          font-size: 20px;
        }
      }
    }
  }
  .faq-title {
    background-color: $white;
    border: 1px solid $border-color;
    cursor: pointer;
    padding: 20px 18px 19px 59px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $black-variant;
    font-size: 18px;
    line-height: 28px;
    position: relative;
    transition: 300ms background-color ease-in-out, 300ms color ease-in-out,
      300ms border ease-in-out;

    @include breakpoint(frommediumlarge) {
      padding: 20px 10px 14px 59px;
    }

    &:before {
      font-family: "Material Icons";
      content: "\e145";
      position: absolute;
      display: block;
      top: 18px;
      left: 19px;
      color: #dadada;
      font-size: 24px;
      transition: 300ms color ease-in-out;
    }

    @media screen and (min-width: 992px) {
      padding: 18px 30px 20px 59px;
    }

    .question {
      width: calc(100% - 30px);
    }

    &:hover,
    &:focus,
    &:active,
    &.active {
      background-color: $red;
      border: 1px solid $red;
      color: #fff;

      &:before {
        color: $white;
      }
    }
  }
  .faq-content {
    display: block;
    padding: 24px 0 4px;
    padding-left: 0 !important;
    padding-right: 0 !important;
    font-size: 18px;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue